export type PlanInterval = (typeof PlanInterval)[keyof typeof PlanInterval];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlanInterval = {
  MONTH: 1,
  YEAR: 12,
  TWO_YEARS: 24,
  THREE_YEARS: 36,
} as const;
